import * as Headless from "@headlessui/react";
import { Fragment, forwardRef } from "react";

import { Link, TouchTarget } from "@/components/clickable";
import { cx } from "@/utils";

let classes = cx(
  // Base
  "flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/6 font-medium text-zinc-950 sm:py-2 sm:text-sm/5",
  // Leading icon/icon-only
  "data-[slot=icon]:*:size-6 data-[slot=icon]:*:shrink-0 data-[slot=icon]:*:fill-zinc-500 sm:data-[slot=icon]:*:size-5",
  // Trailing icon (down chevron or similar)
  "data-[slot=icon]:last:*:ml-auto data-[slot=icon]:last:*:size-5 sm:data-[slot=icon]:last:*:size-4",
  // Avatar
  "data-[slot=avatar]:*:-m-0.5 data-[slot=avatar]:*:size-7 data-[slot=avatar]:*:[--ring-opacity:10%] sm:data-[slot=avatar]:*:size-6",
  // Hover
  "data-[hover]:bg-zinc-950/5 data-[slot=icon]:*:data-[hover]:fill-zinc-950",
  // Active
  "data-[active]:bg-zinc-950/5 data-[slot=icon]:*:data-[active]:fill-zinc-950",
  // Current
  "data-[slot=icon]:*:data-[current]:fill-zinc-950",
);

export const SidebarItem = forwardRef(function SidebarItem(
  { className, children, ...props },

  ref,
) {
  return (
    <span className={cx("relative", className)}>
      {"href" in props ? (
        <Headless.CloseButton as={Fragment} ref={ref}>
          <Link className={classes} {...props} isNav>
            {() => (
              <>
                <TouchTarget>{children}</TouchTarget>
              </>
            )}
          </Link>
        </Headless.CloseButton>
      ) : (
        <Headless.Button
          {...props}
          className={cx("cursor-pointer", classes)}
          ref={ref}
        >
          <TouchTarget>{children}</TouchTarget>
        </Headless.Button>
      )}
    </span>
  );
});

export default SidebarItem;
